

export const priceHelper = {
    withTax,
    withoutTax
};

function withoutTax(price, isTax, taxPercent) {
    if (isTax && taxPercent) {
        let percent = parseInt(taxPercent);
        price = price / (100 + percent) * 100;
        price = Math.round(price);
    }

    return price;
}

function withTax(price, isTax, taxPercent) {
    if (isTax && taxPercent) {
        let percent = parseInt(taxPercent);
        price = price * (100 + percent) / 100;
        price = Math.round(price);
    }

    return price;
}